import { Injectable } from '@angular/core';

@Injectable()
export class accountStatus {
    public _status : any [] = [   
      { value:'ALL', name: 'Todos' },      
        { value:'ACTIVE', name: 'Activo' },
        { value:'INACTIVE', name: 'Inactivo' }       
      ];
    constructor() { }
}



@Injectable()
export class accountType {
    public _accountType : any [] = [         
        { value:'COLLECT', name: 'Recaudo' },
        { value:'WALLET', name: 'Billetera' },
        { value:'BALANCE', name: 'Balance' },
        { value:'SETTLEMENT', name: 'Liquidación' },   
        { value:'CLIENT', name: 'Cliente' },
        { value:'PSP', name: 'PSP' },         
        { value:'BANK', name: 'Banco' },
        { value:'RECEIVABLE', name: 'Recaudo' }   
      ];

    constructor() { }
  }


  @Injectable()
  export class bankName {
      public _bankName : any [] = [         
          { value:'1', name: 'BCP' },
          { value:'2', name: 'BBVA' },
          { value:'3', name: 'Scotiabank' },
          { value:'4', name: 'Interbank' }
        ];
  
      constructor() { }
    }

@Injectable()
export class accountPSPCreation {
    public _accountpspcreation : any [] = [
        { value:0, name: 'TODOS' },
        { value:1, name: 'Este Mes' },
        { value:2, name: 'Esta Semana' },
        { value:3, name: 'Hoy' } ,
        { value:4, name: 'Ayer' } ,
        { value:5, name: 'Semana Pasada' } ,
        { value:6, name: 'Mes Pasado' } ,
        { value:7, name: 'Rango' } 
      ];

    constructor() { }
  }

@Injectable()
export class accountPSPType {
    public _accountPSPType : any [] = [
        { value:'All', name: 'TODOS' },
        { value:'DEPOSIT', name: 'Deposito' },
        { value:'WITHDRAWAL', name: 'Retiro' },
        { value:'TRANSFER', name: 'Transferencia' },
        { value:'PAYMENT', name: 'Pago' },
        { value:'SETTLEMENT', name: 'Liquidación' },
        { value:'SERVICE_FEE', name: 'Comisiones' }        
      ];

    constructor() { }
  }

@Injectable()
export class accountPSPStatus {
    public _accountPSPStatus : any [] = [
      { value:0, name: 'TODOS' },
      { value:1, name: 'Pendientes'},
      { value:2, name: 'CONFIRMADO'},
      { value:3, name: 'CANCELADOS' } 
        
      ];

    constructor() { }
  }


  @Injectable()
export class accountVirtualType {
    public _accountVirtualType : any [] = [
      { value:'All', name: 'TODOS' },
      { value:'PAYMENT', name: 'Pago'},
      { value:'DEPOSIT', name: 'Deposito' }
        
      ];

    constructor() { }
  }

  
@Injectable()
export class accountBankType {
    public _accountBankType : any [] = [
      { value:'All', name: 'TODOS' },
      { value:'PAYMENT', name: 'Pagos'},
      { value:'DEPOSIT', name: 'Depositos' },
      { value:'TRANSFER', name: 'Transferencias' },  
      ];

    constructor() { }
  }

    
@Injectable()
export class accountBankStatus {
    public _accountBankStatus : any [] = [
      { value:0, name: 'TODOS' },
      { value:1, name: 'Pendiente'},
      { value:2, name: 'Confirmado' },
      { value:3, name: 'Cancelado' },  
      { value:4, name: 'Anulado' }
      ];

    constructor() { }
  }



     
@Injectable()
export class accountSettlementStatus {
    public _accountBankStatus : any [] = [
      { value:0, name: 'TODOS' },
      { value:1, name: 'Pendiente'},
      { value:2, name: 'Completo' },
      ];

    constructor() { }
  }


       
@Injectable()
export class accountSettlementCreation {
    public _accountBankStatus : any [] = [
      { value:0, name: 'TODOS' },
        { value:1, name: 'Este Mes' },
        { value:2, name: 'Esta Semana' },
        { value:3, name: 'Hoy' } ,
        { value:4, name: 'Ayer' } ,
        { value:5, name: 'Semana Pasada' } ,
        { value:6, name: 'Mes Pasado' } ,
        { value:7, name: 'Rango' } 
      ];

    constructor() { }
  }


  @Injectable()
export class accountBankCategoryStatus {
    public _accountBankCategoryStatus : any [] = [
      { value:'ALL', name: 'TODOS' },
      { value:'NEW', name: 'Pendiente'},
      { value:'CONFIRMED', name: 'Confirmado' },
      { value:'CANCELLED', name: 'Cancelado' },  
      { value:'CATEGORIZED', name: 'Categorizado' },
      { value:'PROCESSED', name: 'Procesado' },
      { value:'RECONCILED', name: 'Reconciliado' }
      ];

    constructor() { }
  }

  @Injectable()
  export class AccountPayoutCreation {
    public _creation : any [] = [
      { value:0, name: 'TODOS' },
      { value:1, name: 'Este Mes' },
      { value:2, name: 'Esta Semana' },
      { value:3, name: 'Hoy' } ,
      { value:4, name: 'Ayer' } ,
      { value:5, name: 'Semana Pasada' } ,
      { value:6, name: 'Mes Pasado' } ,
      { value:7, name: 'Rango' } 
    ];
  
      constructor() { }
    }

    @Injectable()
  export class AccountPayoutStatus {
      public _status : any [] = [
          { value:0, name: 'TODOS' },
          { value:1, name: 'Pendiente'},
          { value:2, name: 'En Proceso'},
          { value:3, name: 'Completado'},
          { value:4, name: 'Cancelado' }
        ];
  
      constructor() { }
    }

    @Injectable()
  export class AccountPayoutType {
      public _type : any [] = [
          { value:0, name: 'TODOS' },
          { value:1, name: 'Crédito'},
          { value:2, name: 'Débito'},
        ];
  
      constructor() { }
    }